import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/lightbulb': {
    width: 352,
    height: 512,
    paths: [
      {
        d: 'M176 80C123.1 80 80 123.1 80 176 80 184.8 87.2 192 96 192S112 184.8 112 176C112 140.7 140.7 112 176 112 184.8 112 192 104.8 192 96S184.8 80 176 80zM96.1 459.2C96.1 462.3 97 465.4 98.7 468L123.3 504.9C126.2 509.3 131.2 512 136.6 512H215.4C220.8 512 225.8 509.3 228.7 504.9L253.3 468C255 465.4 255.9 462.3 255.9 459.2L256 416H96L96.1 459.2zM176 0C73.7 0 0 83 0 176 0 220.4 16.4 260.9 43.6 291.8 60.2 310.8 86.3 350.6 96 383.9V384H144V383.9C144 379.1 143.3 374.4 141.8 369.8 136.2 352 119 305 79.7 260.1 59.1 236.7 48.1 207 48 176 47.9 102.4 107.7 48 176 48 246.6 48 304 105.4 304 176 304 207 292.8 236.8 272.4 260.1 233.2 304.7 215.9 351.6 210.3 369.6A47.5-47.5 0 0 1 208 383.9V384H256V383.9C265.7 350.6 291.8 310.8 308.5 291.8 335.6 260.9 352 220.4 352 176 352 78.8 273.2 0 176 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/lightbulb.js
// module id = 5A+D
// module chunks = 144